var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg23 = function Svg23(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.604 17.195a.799.799 0 1 1-1.598 0V.793a.799.799 0 1 1 1.598 0zm6.39 0a.799.799 0 1 1-1.598 0V.793a.799.799 0 1 1 1.598 0z",
    fill: "#BABABA"
  })));
};

export default Svg23;